import { ToursList } from '@/components/tours';
import { tourCrudConfig, type Tour } from '@/config/objects/tours';
import { useTourTypeContext } from '@/pages/tour-types/useTourTypeContext';
import { Loading, useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function TourTypeToursTab() {
  const { id } = useParams<{ id: string }>();
  const { tourType, isLoading } = useTourTypeContext();
  const apiClient = useApiClient();

  const tourTypeTourConfig: CrudConfig<Tour> = useMemo(
    () => ({
      ...tourCrudConfig,
      entityName: 'Tour',
      entityNamePlural: 'Tours',
      endpoints: {
        ...tourCrudConfig.endpoints,
        list: `/tour-types/${id}/tours`,
        delete: (tourId: string) => `/tour-types/${id}/tours/${tourId}`,
      },
      listView: {
        ...tourCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/tours',
            where: tourType
              ? {
                  tourTypeId: {
                    not: tourType.id,
                  },
                }
              : undefined,
            onAdd: async (tour: Tour) => {
              await apiClient.post(`/tour-types/${id}/tours`, { tourId: tour.id });
              toast.success('Tour added to tour type');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (tour: Tour) => {
              await apiClient.delete(`/tour-types/${id}/tours/${tour.id}`);
              toast.success('Tour removed from tour type');
            },
          },
        },
      },
    }),
    [tourType, id, apiClient],
  );

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  return <ToursList config={tourTypeTourConfig} className="p-0" baseUrl="/tours" />;
}
